import { render, staticRenderFns } from "./supplementary-agreement-item.vue?vue&type=template&id=13a40ee9&scoped=true&"
import script from "./supplementary-agreement-item.vue?vue&type=script&lang=js&"
export * from "./supplementary-agreement-item.vue?vue&type=script&lang=js&"
import style0 from "./supplementary-agreement-item.vue?vue&type=style&index=0&id=13a40ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a40ee9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a40ee9')) {
      api.createRecord('13a40ee9', component.options)
    } else {
      api.reload('13a40ee9', component.options)
    }
    module.hot.accept("./supplementary-agreement-item.vue?vue&type=template&id=13a40ee9&scoped=true&", function () {
      api.rerender('13a40ee9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/externalPurchases/partials/supplementary-agreement-item.vue"
export default component.exports